/**
 * This function takes an aray of strings and returns a single string, where the
 * array's individual strings are joined by commas, and an "and" before the
 * entry. (EG: ['apples', 'oranges', 'pears] becomes "apples, oranges, and
 * pears")
 */
export function joinStrings(strings: string[]) {
  switch (strings.length) {
    case 0:
      return '';
    case 1:
      return strings[0];
    case 2:
      return strings.join(' and ');
    default:
      return `${strings.slice(0, -1).join(', ')}, and ${strings.slice(-1)}`;
  }
}

/**
 * Removes the last substring from a string if it matches a specific character.
 */
export function removeLastSubstringIfMatch(inputString: string, substringToRemove: string) {
  if (
    inputString.trim().substring(inputString.length - substringToRemove.length) ===
    substringToRemove
  ) {
    return inputString.trim().substring(0, inputString.length - substringToRemove.length);
  } else {
    return inputString;
  }
}
